//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Afooter from "@/components/Afooter";
import { getInfo } from "@/api/my";
import QRCode from "qrcode";
import { Toast } from "vant";
export default {
  name: 'invite',
  data () {
    return {
      title: '邀请好友',
      showShare: false,
      imgHeight: 0,
      imgWidth: 0,
      shareFriendModal: false,
      shareImgUrl: '',
      userInfo: {},
      options: [
        // { name: "微信", icon: "wechat", type: 0 },
        // { name: "朋友圈", icon: "wechat-moments", type: 1 },
        { name: "分享海报", icon: "poster", type: 3 },
        { name: "复制链接", icon: "link", type: 2 },
      ]
    }
  },
  components: {
    Afooter
  },
  methods: {
    onClickLeft () {
      this.$router.goBack()
    },
    onSelect (option) {
      switch (option.type) {
        case 2:
          this.copyUrl();
          break;
        case 3:
          this.sharePost();
          break;
      }
    },
    goMyInvite () {
      this.$router.push({
        path: '/mine/invite'
      })
    },
    getDPR() {
      if (window.devicePixelRatio && window.devicePixelRatio > 1) {
        return window.devicePixelRatio;
      }
      return 1;
    },
    drawImage (maxWidth, maxHeight, objImg) {
      var hRatio
      var wRatio
      var Ratio = 1
      var w = objImg.width
      var h = objImg.height
      wRatio = maxWidth / w
      hRatio = maxHeight / h
      if (maxWidth === 0 && maxHeight === 0) {
        Ratio = 1
      } else if (maxWidth === 0) { //

        if (hRatio < 1) Ratio = hRatio
      } else if (maxHeight === 0) {
        if (wRatio < 1) Ratio = wRatio
      } else if (wRatio < 1 || hRatio < 1) {
        Ratio = (wRatio <= hRatio ? wRatio : hRatio)
      }
      if (Ratio < 1) {
        w = w * Ratio
        h = h * Ratio
      }
      objImg.height = h
      objImg.width = w
      return {
        h,
        wRatio,
        hRatio,
        w,
        Ratio
      }
    },
    inviteFriend () {
      const toast = Toast.loading({
        message: "生成中...",
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: "spinner",
      });
      let width = 1080 
      let height = 1920

      let qrW = 1080 * 1/3
      let qrH = 1080 * 1/3
      let qrTop = height - qrH - 100
      let qrLeft = width/2 - qrW/2

      var canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;
      var context = canvas.getContext("2d");
      context.rect(0, 0, canvas.width, canvas.height);
      context.fillStyle = "transparent";
      context.fill();
      var shareBkImg = new Image();
      shareBkImg.src = "../../../static/invite/invite-bg.png";
      shareBkImg.crossOrigin = "Anonymous";
      let _this = this;
      shareBkImg.onload = function() {
        console.log("img load");
        context.drawImage(shareBkImg, 0, 0, width, height);
          var qrcodeDom = document.getElementById("qrcode");
          let url =
            location.origin +
            '/home' +
            "?inviteCode=" +
            _this.userInfo.inviteCode;
          QRCode.toCanvas(
            qrcodeDom,
            url,
            {
              errorCorrectionLevel: "H",
              type: "image/png",
              quality: 0.3,
              margin: 1,
            },
            function(error, dom) {
              if (error) console.error(error);
              _this.qrcodeImg = dom.toDataURL("image/png");
              let qrImg = new Image();
              qrImg.src = _this.qrcodeImg;
              qrImg.onload = () => {
                context.drawImage(
                  qrImg,
                  qrLeft,
                  qrTop,
                  qrW,
                  qrH
                );
                var base64 = canvas.toDataURL("image/png"); //"image/png" 这里注意一下
                _this.shareImgUrl = base64;
                _this.shareFriendModal = true;
                Toast.clear();
              };
            }
          );
        };
        // }
    },
    sharePost () {
      this.inviteFriend()
      this.showShare = false
    },
    getUserInfo () {
      getInfo().then((res) => {
        this.userInfo = res.data;
      })
    },
    copyUrl () {
      var input = document.createElement("input");
      input.setAttribute("id", "copyInput");
      input.setAttribute("value", location.origin + '/home' + '?inviteCode=' + this.userInfo.inviteCode);
      document.body.appendChild(input);
      document.getElementById("copyInput").select();
      document.execCommand("copy");
      Toast.success("复制链接成功，快去分享给好友吧");
      document.body.removeChild(input);
      this.showShare = false;
    }
  },
  mounted () {

  },
  created () {
    this.getUserInfo()
  }
}



// WEBPACK FOOTER //
// ./src/pages/Invite/index.vue